import PropTypes from 'prop-types';
import React from 'react';

import {pushInteractionTagManager} from '../../services/tagManager';
import './AccreditationButton.style.scss';

export const AccreditationButton = (props) => {
  const openAccreditationModal = () => {
    pushInteractionTagManager({
      screenName: 'credenciamento:home',
      elementType: props.elementType,
      elementContent: props.elementContent
    });
    props.buttonFunctionShowAccreditation();
  };

  return (
    <button
      type="button"
      className="accreditation-button"
      onClick={() => openAccreditationModal()}
    >
      Quero me Credenciar
    </button>
  );
};

AccreditationButton.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func,
  elementType: PropTypes.string,
  elementContent: PropTypes.string
};
